import { useEffect, useState } from 'react';
import {
  withQueryString,
  withSearch,
} from '@plone/volto/components/manage/Blocks/Search/hocs';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { compose } from 'redux';

import Schema, { CONTEXT_FIELD_NAME, relativePathQuery } from './schema';
import { FILTERS_FIELD_NAME, getDefaultSearchFilters } from './schema';
import { SearchBlockViewComponent } from './SearchBlockView';

const SearchBlockEdit = (props) => {
  const {
    block,
    blocksErrors,
    onChangeBlock,
    data,
    selected,
    intl,
    navRoot,
    contentType,
    onTriggerSearch,
    querystring = {},
  } = props;
  const { sortable_indexes = {} } = querystring;
  const [firstRender, setFirstRender] = useState(true);

  const defaultSearchFilters = getDefaultSearchFilters(intl);

  let schema = Schema({ data, intl });

  schema.properties.sortOnOptions.items = {
    choices: Object.keys(sortable_indexes).map((k) => [
      k,
      sortable_indexes[k].title,
    ]),
  };

  const { query = {} } = data || {};
  // We don't need deep compare here, as this is just json serializable data.
  const deepQuery = JSON.stringify(query);

  useEffect(() => {
    onTriggerSearch(
      '',
      data?.facets,
      data?.query?.sort_on,
      data?.query?.sort_order,
    );
  }, [deepQuery, onTriggerSearch, data]);

  // Serve para inicializar o filtro, usado no primeiro uso que nao passa pelo onChangeField
  useEffect(() => {
    if (!data.query?.query && data[FILTERS_FIELD_NAME] && firstRender) {
      const filterDefaults = defaultSearchFilters[data[FILTERS_FIELD_NAME]];
      const {
        query: defaultQuery,
        facets: defaultFacets,
        ...restDefaults
      } = filterDefaults || {};

      onChangeBlock(block, {
        ...data,
        ...restDefaults,
        query: defaultQuery || undefined,
        facets: defaultFacets || undefined,
        context: false,
      });
      setFirstRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data[FILTERS_FIELD_NAME]]);

  const updateQueryWithContext = (query, value) => {
    let updatedQuery = { ...query };

    if (value === true) {
      updatedQuery.query = [...(updatedQuery.query || []), relativePathQuery];
    } else {
      updatedQuery.query = (updatedQuery.query || []).filter(
        (filter) => filter.i !== 'path',
      );
    }

    return updatedQuery;
  };

  return (
    <>
      <SearchBlockViewComponent
        {...props}
        path={getBaseUrl(props.pathname)}
        mode="edit"
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          onChangeField={(id, value) => {
            if (id === FILTERS_FIELD_NAME) {
              const filterDefaults = defaultSearchFilters[value];
              const {
                query: defaultQuery,
                facets: defaultFacets,
                ...restDefaults
              } = filterDefaults || {};

              onChangeBlock(block, {
                ...data,
                ...restDefaults,
                query: defaultQuery || undefined,
                facets: defaultFacets || undefined,
                context: false,
                [id]: value,
              });
              return;
            }

            if (id === CONTEXT_FIELD_NAME) {
              const updatedQuery = updateQueryWithContext(data.query, value);

              onChangeBlock(block, {
                ...data,
                query: updatedQuery,
                [id]: value,
              });
              return;
            }

            if (id === 'itemsPerPage') {
              onChangeBlock(block, {
                ...data,
                query: {
                  ...data.query,
                  b_size: Number(value),
                },
                [id]: value,
              });
              return;
            }

            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};

export default compose(withQueryString, withSearch())(SearchBlockEdit);
